<template>
  <div>
    <h6 class="mb-1">
      {{ $t('Imposto Seletivo') }}
    </h6>
    <b-row>
      <b-col md="3">
        <FormulateInput
          id="tax-parameter-selective-tax-st"
          v-model="fiscalTaxParameter.stSelectiveTaxCode"
          name="tax-parameter-selective-tax-st"
          type="vue-select"
          :options="comboCstCbsIbs"
          :placeholder="$t('Selecione')"
          :label="$t('Situação Trib. Imposto Seletivo')"
        />
      </b-col>
      <b-col md="3">
        <FormulateInput
          id="tax-parameter-selective-tax-fiscal-classification"
          v-model="fiscalTaxParameter.fiscalClassificationSelectiveTaxCode"
          name="tax-parameter-selective-tax-fiscal-classification"
          :disabled="!fiscalTaxParameter.stSelectiveTaxCode"
          type="vue-select"
          :options="comboSelectiveClassTribs"
          :placeholder="$t('Selecione')"
          :label="$t('Classificação Imposto Seletivo')"
        />
      </b-col>
      <b-col md="2">
        <FormulateInput
          id="tax-parameter-selective-tax-type"
          v-model="fiscalTaxParameter.selectiveTaxType"
          name="tax-parameter-selective-tax-type"
          type="vue-select"
          :options="comboSelectiveTaxTypes"
          :label="$t('Tipo de Imposto Seletivo')"
        />
      </b-col>
      <b-col
        v-if="fiscalTaxParameter.selectiveTaxType === 'PERCENTAGE_BY_BASE_VALUE'"
        md="2"
      >
        <FormulateInput
          id="tax-parameter-selective-tax-percent"
          v-model="fiscalTaxParameter.selectiveTaxPercent"
          name="tax-parameter-selective-tax-percent"
          type="text-percetage"
          currency="%"
          :precision="4"
          :label="$t('% Imposto Seletivo')"
          validation="required|number|min:0.00|max:1"
          class="required"
          :validation-messages="{
            ...mxGetTextPercentageValidationMessages,
          }"
        />
      </b-col>
      <b-col
        v-if="fiscalTaxParameter.selectiveTaxType === 'PERCENTAGE_BY_UNIT'"
        md="2"
      >
        <FormulateInput
          id="tax-parameter-selective-tax-value-per-unit"
          v-model="fiscalTaxParameter.selectiveTaxValuePerUnit"
          name="tax-parameter-selective-tax-value-per-unit"
          type="text-percetage"
          currency="R$"
          :precision="4"
          :label="$t('Valor por Unidade Imposto Seletivo')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { formulateHelper } from '@/mixins'
import { BRow, BCol } from 'bootstrap-vue'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'FiscalTaxParameterSelectiveTaxForm',
  components: { BRow, BCol },
  mixins: [formulateHelper],
  props: {
    busy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('pages/invoice/fiscalTaxParameters/fiscalTaxParameterMaintain', [
      'fiscalTaxParameter',
    ]),
    ...mapGetters('pages/invoice/fiscalTaxParameters', [
      'getCstCbsIbs',
      'getClassTribsByCst',
      'getSelectiveTaxTypes',
    ]),
    comboCstCbsIbs() {
      return this.getCstCbsIbs.map(c => ({
        value: c.code,
        label: `${c.code} - ${c.description}`,
      }))
    },
    comboSelectiveClassTribs() {
      const cst = this.fiscalTaxParameter.stSelectiveTaxCode
      const list = this.getClassTribsByCst(cst)
      return list.map(c => ({ value: c.code, label: `${c.code} - ${c.description}` }))
    },
    comboSelectiveTaxTypes() {
      return this.getSelectiveTaxTypes.map(c => ({
        value: c.value,
        label: c.label,
      }))
    },
  },
  watch: {
    'fiscalTaxParameter.stSelectiveTaxCode': function onStSelectiveTaxChange(val, oldVal) {
      if (val) this.fetchClassTribsByCst(val)

      if (!this.busy && val !== oldVal) {
        this.fiscalTaxParameter.fiscalClassificationSelectiveTaxCode = null
      }
    },
  },
  mounted() {
    if (this.fetchCombos) {
      this.fetchCombos()
    }
    if (this.fiscalTaxParameter.stSelectiveTaxCode) {
      this.fetchClassTribsByCst(this.fiscalTaxParameter.stSelectiveTaxCode)
    }
  },
  methods: {
    ...mapActions('pages/invoice/fiscalTaxParameters', ['fetchClassTribsByCst', 'fetchCombos']),
  },
}
</script>
